import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionPlacementType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class PeerOwnershipCommentsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'PeerOwnershipCommentsConfiguration';
  readonly reportSection = ReportSection.PeerOwnershipComments;
  nodataLocalizationKeyName = 'commentary';
  override disabledLayoutWidthControl = true;
  override readonly placementType = ReportSectionPlacementType.Static;
  readonly name = 'peerOwnershipComments';
  readonly displayName = 'Comments';
  readonly reportViewModelSections = [ReportViewModelSection.PeerOwnershipReport_Comments];
  readonly minSize = 4;
  readonly maxSize = 4;
  readonly defaultSize = 4;
  readonly applicableReportTypes = [ReportType.PeerOwnershipReport];
  override get requirePostDataInput(): boolean {
    return true;
  }
  readonly availableDataSections = [];
}
